// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__ge2-o","label":"Category_label__3Q8R0","content":"Category_content__2ds-C","header":"Category_header__1PftQ","location":"Category_location__qsmmv"};